import React from "react";
import { PRESS_LOGOS } from "../mock";

const AsSeenIn = () => {
  return (
    <section className="bg-[#FFF2EC] border-y border-[#1A1410]/10">
      <div className="max-w-7xl mx-auto px-4 py-10 md:py-14">
        <div className="text-center mb-8">
          <span className="text-[11px] md:text-xs uppercase tracking-[0.35em] text-[#1A1410]/60 font-semibold">
            As Seen In
          </span>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-x-10 gap-y-6 md:gap-x-16">
          {PRESS_LOGOS.map((l) => {
            const classes =
              l.style === "serif"
                ? "press-logo font-serif-display text-2xl md:text-3xl font-medium"
                : l.style === "serif-bold"
                ? "press-logo font-serif-display text-2xl md:text-3xl font-bold italic"
                : l.style === "sans-bold"
                ? "press-logo font-display text-2xl md:text-3xl font-extrabold"
                : "press-logo font-display text-xl md:text-2xl font-semibold uppercase";
            return (
              <span key={l.name} className={classes}>
                {l.name}
              </span>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AsSeenIn;
